(function () {
  'use strict';

  if (window.sidizPodiumLayout || document.body.dataset.sidizPodiumAvoidOverlap !== 'true') return;
  window.sidizPodiumLayout = true;

  var pending = false;
  var position = 'right';
  var contactHref = '';
  var chatIntentUntil = 0;
  var wasChatOpen = false;
  var lastContactTrigger = null;
  var contactsDirty = true;
  var elementsDirty = true;
  var criticalElements = [];
  var criticalSelector = [
    '.sidiz-preorder-status', '.product-price--wrapper', '.product-variant--wrapper',
    '.product-actions', '.product-delivery-and-warranty--wrapper', '.product-notice--wrapper',
    '.product-basic-info--wrapper', '.sidiz-stickynav', '.cart__footer',
    'main button', 'main input', 'main select', 'main textarea', 'main summary',
    'main p', 'main h1', 'main h2', 'main h3', 'main a', 'footer input', 'footer button'
  ].join(',');

  function visibleRect(element) {
    if (!element) return null;
    var rect = element.getBoundingClientRect();
    if (!rect.width || !rect.height || rect.bottom <= 0 || rect.top >= window.innerHeight) return null;
    var style = window.getComputedStyle(element);
    return style.display === 'none' || style.visibility === 'hidden' ? null : rect;
  }

  function overlaps(a, b) {
    var margin = 12;
    return a.left < b.right + margin && a.right > b.left - margin &&
      a.top < b.bottom + margin && a.bottom > b.top - margin;
  }

  function setAttribute(element, name, value) {
    if (value === null) {
      if (element.hasAttribute(name)) element.removeAttribute(name);
    } else if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function attachContactLinks() {
    contactHref = '';
    var contacts = document.querySelectorAll('[data-sidiz-header] a[href]');
    contacts.forEach(function (link) {
      var url;
      try { url = new URL(link.href, window.location.href); } catch (_) { return; }
      if (url.origin !== window.location.origin || !/\/pages\/contact(?:-us)?\/?$/.test(url.pathname)) return;
      var label = link.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (label.indexOf('contact sidiz australia') !== 0 && label.indexOf('talk with local support') !== 0) return;
      contactHref = link.getAttribute('href');
      setAttribute(link, 'data-sidiz-webchat-contact', '');
    });
    if (!contactHref) return;
    document.querySelectorAll('.product-actions').forEach(function (actions) {
      if (actions.parentElement.querySelector('.sidiz-webchat-inline')) return;
      var link = document.createElement('a');
      link.className = 'sidiz-webchat-inline';
      link.href = contactHref;
      link.textContent = document.body.dataset.sidizPodiumContactLabel || 'Ask a question';
      link.setAttribute('data-sidiz-webchat-contact', '');
      actions.insertAdjacentElement('afterend', link);
    });
  }

  function modalOpen() {
    return !!document.querySelector('cart-drawer.active, cart-notification.active, dialog[open], .modal-360:not(.hidden)') ||
      document.body.classList.contains('sidiz-nav-open');
  }

  function chatOpen(widget) {
    return Array.prototype.some.call(widget.querySelectorAll('iframe'), function (frame) {
      if (frame.id === 'podium-bubble' || frame.id === 'podium-prompt') return false;
      var rect = visibleRect(frame);
      return rect && rect.width > 200 && rect.height > 200;
    });
  }

  function update() {
    pending = false;
    if (contactsDirty) {
      contactsDirty = false;
      attachContactLinks();
    }
    if (elementsDirty) {
      elementsDirty = false;
      criticalElements = Array.prototype.slice.call(document.querySelectorAll(criticalSelector));
    }
    var widget = document.getElementById('podium-website-widget');
    var bubble = document.getElementById('podium-bubble');
    if (!widget || !bubble) return;

    var modal = modalOpen();
    setAttribute(widget, 'data-sidiz-podium-modal-hidden', modal ? '' : null);
    if (modal) return;

    // Restore focus to the initiating link when the customer's native close control is used.
    if (chatOpen(widget)) {
      wasChatOpen = true;
      return;
    }
    if (wasChatOpen) {
      wasChatOpen = false;
      chatIntentUntil = 0;
      if (lastContactTrigger && lastContactTrigger.isConnected &&
          (document.activeElement === document.body || widget.contains(document.activeElement))) {
        lastContactTrigger.focus({ preventScroll: true });
      }
      lastContactTrigger = null;
    }
    if (document.activeElement === bubble || Date.now() < chatIntentUntil) return;

    var width = bubble.getBoundingClientRect().width || 160;
    var height = bubble.getBoundingClientRect().height || 100;
    var viewport = window.visualViewport;
    var bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
    var candidates = {
      right: { left: window.innerWidth - width, right: window.innerWidth, top: bottom - height, bottom: bottom },
      left: { left: 0, right: width, top: bottom - height, bottom: bottom }
    };
    var obstacles = [];
    criticalElements.forEach(function (element) {
      var rect = visibleRect(element);
      if (rect) obstacles.push(rect);
    });
    var focusRect = visibleRect(document.activeElement);
    if (focusRect && document.activeElement !== document.body) obstacles.push(focusRect);
    function clear(side) { return !obstacles.some(function (rect) { return overlaps(candidates[side], rect); }); }

    var other = position === 'right' ? 'left' : 'right';
    var selected = clear(position) ? position : clear(other) ? other : null;
    // Never remove the sole contact entry point if a customised header has no contact link.
    var hidden = !selected && !!contactHref;
    if (selected) position = selected;
    setAttribute(widget, 'data-sidiz-podium-position', position);
    setAttribute(widget, 'data-sidiz-podium-launcher-hidden', hidden ? '' : null);
  }

  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(update);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-sidiz-webchat-contact]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    var api = window.PodiumWebChat;
    if (!api || typeof api.open !== 'function') return;
    event.preventDefault();
    lastContactTrigger = link;
    chatIntentUntil = Date.now() + 1500;
    window.setTimeout(schedule, 1550);
    var menuClose = document.querySelector('[data-sidiz-menu-close]');
    if (document.body.classList.contains('sidiz-nav-open') && menuClose) menuClose.click();
    var details = link.closest('details');
    if (details) details.removeAttribute('open');
    var widget = document.getElementById('podium-website-widget');
    if (widget) {
      widget.removeAttribute('data-sidiz-podium-launcher-hidden');
      widget.removeAttribute('data-sidiz-podium-modal-hidden');
    }
    try {
      var opened = api.open();
      if (opened && typeof opened.catch === 'function') opened.catch(function () { window.location.assign(link.href); });
    } catch (_) { window.location.assign(link.href); }
  });

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  document.addEventListener('change', schedule);
  document.addEventListener('load', schedule, true);
  function refresh() { contactsDirty = true; elementsDirty = true; schedule(); }
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule, { passive: true });
    window.visualViewport.addEventListener('scroll', schedule, { passive: true });
  }
  new MutationObserver(function (records) {
    var changed = false;
    records.forEach(function (record) {
      var target = record.target;
      if (target.nodeType !== 1) return;
      if (record.type === 'childList') {
        if (target.closest('main, footer, [data-sidiz-header]')) {
          elementsDirty = true;
          if (target.closest('[data-sidiz-header]')) contactsDirty = true;
          changed = true;
        }
        if (target === document.body || target.closest('#podium-website-widget')) changed = true;
      } else if (target.matches('body, cart-drawer, cart-notification, dialog, .modal-360') || target.closest('#podium-website-widget')) {
        changed = true;
      }
    });
    if (changed) schedule();
  }).observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['class', 'style', 'open', 'aria-hidden', 'aria-expanded']
  });
  schedule();
}());
